/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { styled } from '@mui/material/styles';
import { ButtonBack, ButtonNext, Slider } from 'pure-react-carousel';
interface StyledButtonProps {
	alpha?: boolean;
}

const baseStyles = {
	width: '50px',
	height: '50px',
	borderRadius: '50%',
	cursor: 'pointer',
	border: 'none',
	marginLeft: '10px',
	marginRight: '10px',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	backdropFilter: 'blur(10px)',
};

export const CarouselSlider = styled(Slider)({});

export const IconButtonBack = styled(ButtonBack)<StyledButtonProps>(({ alpha, theme }) => ({
	opacity: alpha ? 0.6 : 1,
	backgroundColor: theme.palette.grey[500] + '!important',
	color: theme.palette.background.paper,
	'&:hover': {
		border: 'none',
		color: theme.palette.background.paper + '!important',
	},
	...baseStyles,
}));

export const IconButtonNext = styled(ButtonNext)<StyledButtonProps>(({ alpha, theme }) => ({
	opacity: alpha ? 0.6 : 1,
	backgroundColor: theme.palette.grey[500] + '!important',
	color: theme.palette.background.paper,
	right: '10px !important',
	'&:hover': {
		border: 'none',
		color: theme.palette.background.paper + '!important',
	},
	...baseStyles,
}));
